<template>
	<div>
		<router-view />
	</div>
    <van-floating-bubble v-if="showHomeButton" @click="toHome()" icon="arrow-left" :offset="{x: 20, y: 20}" style="background-color: #000; box-shadow:0 0 10rem rgba(0, 0, 0, 0.15);" />
</template>

<script setup>
import { onMounted, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import cookie from "cookie.js";

const store = useStore()
const router = useRouter(), route = useRoute()
const showHomeButton = ref(false)

const isMobile = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
}
if (!isMobile()) {
	window.location.href = 'https://www.jiuselu.net/'
}
onMounted(() => {
	store.dispatch('getWebsitConfig')
})

watch(() => route.query, (param) => {
    if(param.share) {
        showHomeButton.value = true
    } else {
        showHomeButton.value = false
    }
})
if (!store.state.login.userInfo.id && cookie.get('accessToken')) {
	store.dispatch('getUserInfo')
}

const toHome = () => {
    router.replace('/')
}

</script>

<style lang="scss" scoped></style>
